"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyCodes = void 0;
var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["KEY_CANCEL"] = 3] = "KEY_CANCEL";
    KeyCodes[KeyCodes["KEY_HELP"] = 6] = "KEY_HELP";
    KeyCodes[KeyCodes["KEY_BACK_SPACE"] = 8] = "KEY_BACK_SPACE";
    KeyCodes[KeyCodes["KEY_TAB"] = 9] = "KEY_TAB";
    KeyCodes[KeyCodes["KEY_CLEAR"] = 12] = "KEY_CLEAR";
    KeyCodes[KeyCodes["KEY_RETURN"] = 13] = "KEY_RETURN";
    KeyCodes[KeyCodes["KEY_ENTER"] = 14] = "KEY_ENTER";
    KeyCodes[KeyCodes["KEY_SHIFT"] = 16] = "KEY_SHIFT";
    KeyCodes[KeyCodes["KEY_CONTROL"] = 17] = "KEY_CONTROL";
    KeyCodes[KeyCodes["KEY_ALT"] = 18] = "KEY_ALT";
    KeyCodes[KeyCodes["KEY_PAUSE"] = 19] = "KEY_PAUSE";
    KeyCodes[KeyCodes["KEY_CAPS_LOCK"] = 20] = "KEY_CAPS_LOCK";
    KeyCodes[KeyCodes["KEY_ESCAPE"] = 27] = "KEY_ESCAPE";
    KeyCodes[KeyCodes["KEY_SPACE"] = 32] = "KEY_SPACE";
    KeyCodes[KeyCodes["KEY_PAGE_UP"] = 33] = "KEY_PAGE_UP";
    KeyCodes[KeyCodes["KEY_PAGE_DOWN"] = 34] = "KEY_PAGE_DOWN";
    KeyCodes[KeyCodes["KEY_END"] = 35] = "KEY_END";
    KeyCodes[KeyCodes["KEY_HOME"] = 36] = "KEY_HOME";
    KeyCodes[KeyCodes["KEY_LEFT"] = 37] = "KEY_LEFT";
    KeyCodes[KeyCodes["KEY_UP"] = 38] = "KEY_UP";
    KeyCodes[KeyCodes["KEY_RIGHT"] = 39] = "KEY_RIGHT";
    KeyCodes[KeyCodes["KEY_DOWN"] = 40] = "KEY_DOWN";
    KeyCodes[KeyCodes["KEY_PRINTSCREEN"] = 44] = "KEY_PRINTSCREEN";
    KeyCodes[KeyCodes["KEY_INSERT"] = 45] = "KEY_INSERT";
    KeyCodes[KeyCodes["KEY_DELETE"] = 46] = "KEY_DELETE";
    KeyCodes[KeyCodes["KEY_0"] = 48] = "KEY_0";
    KeyCodes[KeyCodes["KEY_1"] = 49] = "KEY_1";
    KeyCodes[KeyCodes["KEY_2"] = 50] = "KEY_2";
    KeyCodes[KeyCodes["KEY_3"] = 51] = "KEY_3";
    KeyCodes[KeyCodes["KEY_4"] = 52] = "KEY_4";
    KeyCodes[KeyCodes["KEY_5"] = 53] = "KEY_5";
    KeyCodes[KeyCodes["KEY_6"] = 54] = "KEY_6";
    KeyCodes[KeyCodes["KEY_7"] = 55] = "KEY_7";
    KeyCodes[KeyCodes["KEY_8"] = 56] = "KEY_8";
    KeyCodes[KeyCodes["KEY_9"] = 57] = "KEY_9";
    KeyCodes[KeyCodes["KEY_SEMICOLON"] = 59] = "KEY_SEMICOLON";
    KeyCodes[KeyCodes["KEY_EQUALS"] = 61] = "KEY_EQUALS";
    KeyCodes[KeyCodes["KEY_A"] = 65] = "KEY_A";
    KeyCodes[KeyCodes["KEY_B"] = 66] = "KEY_B";
    KeyCodes[KeyCodes["KEY_C"] = 67] = "KEY_C";
    KeyCodes[KeyCodes["KEY_D"] = 68] = "KEY_D";
    KeyCodes[KeyCodes["KEY_E"] = 69] = "KEY_E";
    KeyCodes[KeyCodes["KEY_F"] = 70] = "KEY_F";
    KeyCodes[KeyCodes["KEY_G"] = 71] = "KEY_G";
    KeyCodes[KeyCodes["KEY_H"] = 72] = "KEY_H";
    KeyCodes[KeyCodes["KEY_I"] = 73] = "KEY_I";
    KeyCodes[KeyCodes["KEY_J"] = 74] = "KEY_J";
    KeyCodes[KeyCodes["KEY_K"] = 75] = "KEY_K";
    KeyCodes[KeyCodes["KEY_L"] = 76] = "KEY_L";
    KeyCodes[KeyCodes["KEY_M"] = 77] = "KEY_M";
    KeyCodes[KeyCodes["KEY_N"] = 78] = "KEY_N";
    KeyCodes[KeyCodes["KEY_O"] = 79] = "KEY_O";
    KeyCodes[KeyCodes["KEY_P"] = 80] = "KEY_P";
    KeyCodes[KeyCodes["KEY_Q"] = 81] = "KEY_Q";
    KeyCodes[KeyCodes["KEY_R"] = 82] = "KEY_R";
    KeyCodes[KeyCodes["KEY_S"] = 83] = "KEY_S";
    KeyCodes[KeyCodes["KEY_T"] = 84] = "KEY_T";
    KeyCodes[KeyCodes["KEY_U"] = 85] = "KEY_U";
    KeyCodes[KeyCodes["KEY_V"] = 86] = "KEY_V";
    KeyCodes[KeyCodes["KEY_W"] = 87] = "KEY_W";
    KeyCodes[KeyCodes["KEY_X"] = 88] = "KEY_X";
    KeyCodes[KeyCodes["KEY_Y"] = 89] = "KEY_Y";
    KeyCodes[KeyCodes["KEY_Z"] = 90] = "KEY_Z";
    KeyCodes[KeyCodes["KEY_LEFT_CMD"] = 91] = "KEY_LEFT_CMD";
    KeyCodes[KeyCodes["KEY_RIGHT_CMD"] = 93] = "KEY_RIGHT_CMD";
    KeyCodes[KeyCodes["KEY_CONTEXT_MENU"] = 93] = "KEY_CONTEXT_MENU";
    KeyCodes[KeyCodes["KEY_NUMPAD0"] = 96] = "KEY_NUMPAD0";
    KeyCodes[KeyCodes["KEY_NUMPAD1"] = 97] = "KEY_NUMPAD1";
    KeyCodes[KeyCodes["KEY_NUMPAD2"] = 98] = "KEY_NUMPAD2";
    KeyCodes[KeyCodes["KEY_NUMPAD3"] = 99] = "KEY_NUMPAD3";
    KeyCodes[KeyCodes["KEY_NUMPAD4"] = 100] = "KEY_NUMPAD4";
    KeyCodes[KeyCodes["KEY_NUMPAD5"] = 101] = "KEY_NUMPAD5";
    KeyCodes[KeyCodes["KEY_NUMPAD6"] = 102] = "KEY_NUMPAD6";
    KeyCodes[KeyCodes["KEY_NUMPAD7"] = 103] = "KEY_NUMPAD7";
    KeyCodes[KeyCodes["KEY_NUMPAD8"] = 104] = "KEY_NUMPAD8";
    KeyCodes[KeyCodes["KEY_NUMPAD9"] = 105] = "KEY_NUMPAD9";
    KeyCodes[KeyCodes["KEY_MULTIPLY"] = 106] = "KEY_MULTIPLY";
    KeyCodes[KeyCodes["KEY_ADD"] = 107] = "KEY_ADD";
    KeyCodes[KeyCodes["KEY_SEPARATOR"] = 108] = "KEY_SEPARATOR";
    KeyCodes[KeyCodes["KEY_SUBTRACT"] = 109] = "KEY_SUBTRACT";
    KeyCodes[KeyCodes["KEY_DECIMAL"] = 110] = "KEY_DECIMAL";
    KeyCodes[KeyCodes["KEY_DIVIDE"] = 111] = "KEY_DIVIDE";
    KeyCodes[KeyCodes["KEY_F1"] = 112] = "KEY_F1";
    KeyCodes[KeyCodes["KEY_F2"] = 113] = "KEY_F2";
    KeyCodes[KeyCodes["KEY_F3"] = 114] = "KEY_F3";
    KeyCodes[KeyCodes["KEY_F4"] = 115] = "KEY_F4";
    KeyCodes[KeyCodes["KEY_F5"] = 116] = "KEY_F5";
    KeyCodes[KeyCodes["KEY_F6"] = 117] = "KEY_F6";
    KeyCodes[KeyCodes["KEY_F7"] = 118] = "KEY_F7";
    KeyCodes[KeyCodes["KEY_F8"] = 119] = "KEY_F8";
    KeyCodes[KeyCodes["KEY_F9"] = 120] = "KEY_F9";
    KeyCodes[KeyCodes["KEY_F10"] = 121] = "KEY_F10";
    KeyCodes[KeyCodes["KEY_F11"] = 122] = "KEY_F11";
    KeyCodes[KeyCodes["KEY_F12"] = 123] = "KEY_F12";
    KeyCodes[KeyCodes["KEY_F13"] = 124] = "KEY_F13";
    KeyCodes[KeyCodes["KEY_F14"] = 125] = "KEY_F14";
    KeyCodes[KeyCodes["KEY_F15"] = 126] = "KEY_F15";
    KeyCodes[KeyCodes["KEY_F16"] = 127] = "KEY_F16";
    KeyCodes[KeyCodes["KEY_F17"] = 128] = "KEY_F17";
    KeyCodes[KeyCodes["KEY_F18"] = 129] = "KEY_F18";
    KeyCodes[KeyCodes["KEY_F19"] = 130] = "KEY_F19";
    KeyCodes[KeyCodes["KEY_F20"] = 131] = "KEY_F20";
    KeyCodes[KeyCodes["KEY_F21"] = 132] = "KEY_F21";
    KeyCodes[KeyCodes["KEY_F22"] = 133] = "KEY_F22";
    KeyCodes[KeyCodes["KEY_F23"] = 134] = "KEY_F23";
    KeyCodes[KeyCodes["KEY_F24"] = 135] = "KEY_F24";
    KeyCodes[KeyCodes["KEY_NUM_LOCK"] = 144] = "KEY_NUM_LOCK";
    KeyCodes[KeyCodes["KEY_SCROLL_LOCK"] = 145] = "KEY_SCROLL_LOCK";
    KeyCodes[KeyCodes["KEY_COMMA"] = 188] = "KEY_COMMA";
    KeyCodes[KeyCodes["KEY_PERIOD"] = 190] = "KEY_PERIOD";
    KeyCodes[KeyCodes["KEY_SLASH"] = 191] = "KEY_SLASH";
    KeyCodes[KeyCodes["KEY_BACK_QUOTE"] = 192] = "KEY_BACK_QUOTE";
    KeyCodes[KeyCodes["KEY_OPEN_BRACKET"] = 219] = "KEY_OPEN_BRACKET";
    KeyCodes[KeyCodes["KEY_BACK_SLASH"] = 220] = "KEY_BACK_SLASH";
    KeyCodes[KeyCodes["KEY_CLOSE_BRACKET"] = 221] = "KEY_CLOSE_BRACKET";
    KeyCodes[KeyCodes["KEY_QUOTE"] = 222] = "KEY_QUOTE";
    KeyCodes[KeyCodes["KEY_META"] = 224] = "KEY_META";
})(KeyCodes = exports.KeyCodes || (exports.KeyCodes = {}));
//# sourceMappingURL=keyCodes.js.map